var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,_vm._g({tag:"component",class:['bigButton', _vm.classObj],attrs:{"to":_vm.to}},_vm.$listeners),[_c('Spinner',{class:['bigButton__spinner', { actived: _vm.busy }]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }